module.exports = "<canvas data-no-op-canvas></canvas>\n<p data-no-op-msg><%=message%><p>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/no_op/public/error.html
 ** module id = 139
 ** module chunks = 0
 **/